module.exports = require("/var/www/konstytucja3maj/src/store/createStore")